// **  Initial State
const initialState = {
  userData: {},
  firebaseToken: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        userData: action.data,
        // [action.config.storageTokenKeyName]:
        //   action[action.config.storageTokenKeyName],
        // [action.config.storageRefreshTokenKeyName]:
        //   action[action.config.storageRefreshTokenKeyName],
      };
    case "LOGOUT":
      // const obj = { ...action };
      // delete obj.type;
      return initialState;

    case "SAVE_FIREBASE_TOKEN":
      return { ...state, firebaseToken: action.data };

    case "UPDATE_LOGGED_IN_USER":
      let cState = { ...state };
      let cUserData = { ...cState.userData };
      cUserData.user = action.data;
      return {
        ...state,
        userData: cUserData,
      };
    default:
      return state;
  }
};

export default authReducer;
